import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Reveal from "../components/Reveal";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { sanitizeHtml } from "../lib/sanitize";
import { contact } from "../mock";
import { ArrowLeft, Calendar, User, Loader2, MessageCircle } from "lucide-react";

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const fetchPost = useCallback(() => {
    setLoading(true);
    api.get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    fetchPost();
  }, [fetchPost]);

  useSeo(post?.seo || {}, post ? `${post.title} | DaddyAnna` : "Blog | DaddyAnna");

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#00ff87]" size={40} /></div>;
  }
  if (notFound || !post) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4">
        <h1 className="font-display text-3xl text-white">Post not found</h1>
        <button onClick={() => navigate("/blog")} className="btn-neon px-6 py-3 rounded-xl font-semibold">Back to Blog</button>
      </div>
    );
  }

  return (
    <main className="pt-32 pb-24">
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-[#00ff87] text-sm mb-6 hover:gap-3 transition-all">
          <ArrowLeft size={16} /> Back to Blog
        </Link>
        <Reveal>
          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-4">
            <span className="inline-flex items-center gap-1.5"><Calendar size={14} /> {new Date(post.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
            <span className="inline-flex items-center gap-1.5"><User size={14} /> {post.author}</span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight mb-6">{post.title}</h1>
          {post.coverImage && (
            <img src={post.coverImage} alt={post.title} className="w-full rounded-2xl border border-[#00ff87]/15 mb-8" />
          )}
          <div
            className="prose-da text-gray-300 leading-relaxed space-y-4"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.content) }}
          />
          {post.tags?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-8">
              {post.tags.map((t) => (
                <span key={t} className="px-3 py-1 rounded-full bg-[#00ff87]/10 border border-[#00ff87]/20 text-[#00ff87] text-xs">#{t}</span>
              ))}
            </div>
          )}
          <div className="mt-10 rounded-2xl border border-[#00ff87]/20 bg-[#0c0d17] p-6 text-center">
            <p className="text-white font-display font-semibold text-lg mb-4">Ready to get your Online Cricket ID?</p>
            <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="btn-neon inline-flex items-center gap-2 px-7 py-3 rounded-xl font-semibold">
              <MessageCircle size={18} /> Get Cricket ID on WhatsApp
            </a>
          </div>
        </Reveal>
      </article>
    </main>
  );
};

export default BlogPost;
